export default "__VITE_ASSET__D4pF1Ev0__"